import type * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/lib/utils';

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
      <ProgressPrimitive.Root
          data-slot="progress"
          className={cn("bb:bg-primary/20 bb:relative bb:h-2 bb:w-full bb:overflow-hidden bb:rounded-full", className)}
          {...props}
      >
          <ProgressPrimitive.Indicator
              data-slot="progress-indicator"
              className="bb:bg-primary bb:h-full bb:w-full bb:flex-1 bb:transition-all"
              style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
          />
      </ProgressPrimitive.Root>
  );
}

export { Progress };
